<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <span
    data-slot="color-key-label"
    :class="
      cn(
        'line-clamp-2 font-normal group-data-[layout=hero]/color-key:mb-1 group-data-[layout=hero]/color-key:truncate group-data-[layout=hero]/color-key:text-secondary',
        props.class,
      )
    "
  >
    <slot />
  </span>
</template>
